export default "<p>\n  page-not-found works! but why?\n</p>\n"